import { render, staticRenderFns } from "./KpiCollectionVertical.vue?vue&type=template&id=bc164c24&scoped=true&"
import script from "./KpiCollectionVertical.vue?vue&type=script&lang=js&"
export * from "./KpiCollectionVertical.vue?vue&type=script&lang=js&"
import style0 from "./KpiCollectionVertical.vue?vue&type=style&index=0&id=bc164c24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc164c24",
  null
  
)

export default component.exports